export const getLastLocation = () =>
  JSON.parse(localStorage.getItem("lastLocation"));

export const storeLastLocation = (userType) =>
  localStorage.setItem("lastLocation", JSON.stringify(userType));

export const removeLastLocation = () => localStorage.removeItem("lastLocation");
